// extracted by mini-css-extract-plugin
export default {"MostList":"Ktv_MostList__It0lX","List":"Ktv_List__dGpnj","Container":"Ktv_Container__qpHL6"};